module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "Chapno"
  }, [_c('b', [_vm._v("FABRICS AND MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "afttxt"
  }, [_c('i', [_vm._v("Let’s review the fabrics, materials, and tools you’ll need.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There are a variety of suitable fabrics for making up the little animals in this book. I have listed a few of my favorite options below.")]), _vm._v(" "), _c('p', {
    staticClass: "head2"
  }, [_vm._v("Kunin Plush Felt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Kunin "), _c('i', [_vm._v("plush")]), _vm._v(" felt (available at "), _c('a', {
    attrs: {
      "href": "http://kuninfelt.com",
      "target": "_blank"
    }
  }, [_vm._v("kuninfelt.com")]), _vm._v(") is thicker than regular felt, and it has a raised pile, meaning it is not completely flat like regular Kunin felt. This plush felt is my favorite fabric to use for these projects because it is easy to cut and sew. It also comes in a wide variety of colors, so it will work for any of the animals. It’s made from 100% recycled postconsumer plastic bottles. This fabric can sometimes stretch more than you’d like it to, so be careful when stuffing your plush felt softies. I highly recommend that you use Kunin plush felt.")]), _vm._v(" "), _c('p', {
    staticClass: "head2"
  }, [_vm._v("Cuddle Fleece")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cuddle fleece fabric is super soft and durable, and it comes in a myriad of colors. It’s easy to both cut and sew, and it does not fray. This is a great option if you’re looking to make a softie that is great for cuddling. Notes to remember when using cuddle fleece:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/ht.jpg"
    }
  }), _vm._v("  The right and wrong sides of the fabric can be very similar, so be careful and consistent when choosing the right side. In general, you "), _c('i', [_vm._v("can")]), _vm._v(" use either side of the fabric, but you want to make sure all the pieces of your softie match.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/ht.jpg"
    }
  }), _vm._v("  Cuddle fleece fabric has a longer pile than plush felt, and it can be hard to spot the direction of the pile. You’ll notice that if you brush it one way it looks lighter, and if you brush it the other way it looks darker. We’ll learn more about pile and why it’s important later; see Direction of the Fabric Pile.")]), _vm._v(" "), _c('p', {
    staticClass: "head2"
  }, [_vm._v("Felt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I prefer to use standard felt for many of the accessories. A wool/viscose blend is best. Acrylic felt should be avoided; it is usually thin and does not hold its shape.")]), _vm._v(" "), _c('div', {
    staticClass: "bbox"
  }, [_c('p', {
    staticClass: "notehd"
  }, [_c('b', [_c('i', [_vm._v("More About Choosing a Fabric")])])]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("1.")]), _vm._v(" Any fabric that has a relatively short pile can be used. Fabric with a longer pile will make cutting and sewing much more difficult and is not suitable for these projects. You want the fabric to feel fuzzy, not furry.")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("2.")]), _vm._v(" You can find suitable fabrics in craft stores or online. If you can’t head to a store to actually see and feel the fabric, most retailers offer a swatch service, which is very helpful for trying new fabrics. Buy small amounts of fabrics until you decide which you like working with best.")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("3.")]), _vm._v(" Your fabric should be soft and pliable. You’ll need it to fold easily while you’re making your softie, and you want it to be nice to hold and squeeze after it’s finished.")])]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("Needles")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You will need three needles:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/ht.jpg"
    }
  }), _vm._v("  A standard sharp hand-sewing needle for sewing the fabric together")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/ht.jpg"
    }
  }), _vm._v("  A large-eyed sharp hand-sewing needle for embroidery")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/ht.jpg"
    }
  }), _vm._v("  A long (approximately 3˝), sharp hand-sewing needle, sometimes called a doll needle, for sewing the eye buttons")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You will be able to find all three types of needles in a craft store, online, or maybe even around the house.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("Thread")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You will also need three types of thread:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/ht.jpg"
    }
  }), _vm._v("  Standard all-purpose thread that matches the color of your chosen fabric, for sewing the softie together")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/ht.jpg"
    }
  }), _vm._v("  Black embroidery thread, for embroidering the face")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/ht.jpg"
    }
  }), _vm._v("  Black extra-strong thread, for sewing on the eye buttons")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You will be able to find all three types of thread in a craft store or online. If you want to reduce the number of colors you need to purchase, I suggest sticking with browns, grays, and whites.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("Stuffing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can use any kind of toy or pillow stuffing to fill your softies. The most common kind is polyester fiberfill, which is what I use.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("Long Sewing Pins")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ordinary sewing pins will work fine, but long sewing pins will be easier to use for these projects. I also recommend buying pins with colored heads, which will make it easier to keep track of them in your project.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("Sew-On Eyes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each softie will need a pair of plastic sew-on eyes. Eyes around ¼˝ (6mm) will fit well. Try finding them on Etsy or at a local craft shop. If you prefer, you can also forgo these materials and use embroidery thread to stitch two black dots for eyes. Embroidered eyes are the safer choice if you choose to make a softie for a young child. Never share a softie with detachable parts or accessories with an infant.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("Scissors")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You will need a sharp pair of scissors that you use exclusively for cutting thread and fabric. You never want to use your sewing scissors for cutting paper or other materials, or they’ll get dull fast! Fleece is especially difficult to cut without sharp scissors.")]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("Fabric Pen")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To mark your fabric, you will need a water-erasable fabric pen. Marks from this type of fabric pen will disappear with water.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("Black Pom-Poms")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Small black pom-poms make the perfect noses for these adorable softies. Look for options that are about ⅜˝ (10mm) in size, online or at your local craft store. Larger black or brown pom-poms, 1¼˝ (30mm), can also be used for the horse’s mane.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_vm._v("Pink or Red Colored Pencil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I love adding a bit of blush to the cheeks of some softies. Any kind of watercolor pencil in pink or red will work.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2238e798","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_chapter01.vue
// module id = 78
// module chunks = 0